import { render, staticRenderFns } from "./LiveBadge.vue?vue&type=template&id=342885ce&scoped=true"
import script from "./LiveBadge.vue?vue&type=script&lang=ts"
export * from "./LiveBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342885ce",
  null
  
)

export default component.exports